export const ORGANIZATION_TYPES_STATUS = {
  active: 'Active',
  inactive: 'Inactive',
};
